import { heightAtLatLng } from "../../utils/mapping-functions";
import SETTINGS from "../../settings";
import { Extrude } from "drei";
import log from "loglevel";

const Neighbours = (props) => {
  let neighbours = [];
  const heightMap = props.heightMap;
  const buildings = props.heightMap.buildings;
  const size = heightMap.boundBox.size;
  const min = heightMap.heightLimits.min;
  const scale = SETTINGS.TERRAIN.SCALE;

  if (buildings.length > 0) {
    for (let i = 0; i < buildings.length; i++) {
      // for (let i = 0; i < 15; i++) {
      let buildingsPosition = [];
      console.log(buildings[i].positionsArray);
      for (let j = 0; j < buildings[i].positionsArray.length; j++) {
        const point = heightAtLatLng(buildings[i].positionsArray[j], heightMap);
        buildingsPosition.push(
          new THREE.Vector3(
            (point.x * size.x - size.x / 2) / scale,
            (point.z - min) / scale,
            (point.y * size.y - size.y / 2) / scale
          )
        );
      }
      neighbours.push(buildingsPosition);
    }
  }
  const extrudeSettings = {
    steps: 1,
    depth: 3 / scale,
    bevelEnabled: false,
  };
  return (
    <group>
      {neighbours.map((bldg, i) => {
        let shape = new THREE.Shape();
        shape.moveTo(
          bldg[0].getComponent(0),
          bldg[0].getComponent(2),
          bldg[0].getComponent(1)
        );
        let minheight = 1000000;
        let maxheight = -1000000;
        let heightDifference;
        for (let j = 1; j < bldg.length; j++) {
          shape.lineTo(
            bldg[j].getComponent(0),
            bldg[j].getComponent(2),
            bldg[j].getComponent(1)
          );
          if (bldg[j].getComponent(1) < minheight) {
            minheight = bldg[j].getComponent(1);
          }
          if (bldg[j].getComponent(1) > maxheight) {
            maxheight = bldg[j].getComponent(1);
          }
          heightDifference = maxheight - minheight;
        }
        return (
          <group key={i}>
            <Extrude
              castShadow
              args={[
                shape,
                {
                  steps: 1,
                  depth: -heightDifference - 3 / scale,
                  bevelEnabled: false,
                },
              ]}
              position={[0, minheight, 0]}
              rotation={[Math.PI / 2, 0, 0]}
              onUpdate={(self) => (self.verticesNeedUpdate = true)}
            >
              <meshToonMaterial
                attach="material"
                color={0xffffff}
                side={THREE.DoubleSide}
              />
            </Extrude>
            <line position={1 / scale}>
              <geometry
                attach="geometry"
                vertices={bldg}
                onUpdate={(self) => (self.verticesNeedUpdate = true)}
              />
              <lineBasicMaterial attach="material" color={0x003300} />
            </line>
          </group>
        );
      })}
    </group>
  );
};

export default React.memo(Neighbours);
